// Libs
import { ModelBase } from "@shoothill/core";
import * as MobX from "mobx";
// App
import { ArmedForcesProofDTO } from "Globals/Models/DTO/ArmedForcesProofDTO";

export class ArmedForcesProofModel extends ModelBase<ArmedForcesProofModel, ArmedForcesProofDTO> {
    @MobX.observable public id: string | null = null;
    @MobX.observable public employmentDetailId: string = "";
    @MobX.observable public fileName: string = "";
    @MobX.observable public fileUrl: string = "";
    @MobX.observable public createdDate: Date | null = null;
    @MobX.observable public isDeleted: boolean = false;

    @MobX.action
    public fromDto = (model: ArmedForcesProofDTO): void => {
        if (model !== null && model !== undefined) {
            this.id = model.id;
            this.employmentDetailId = model.employmentDetailId;
            this.fileName = model.fileName;
            this.fileUrl = model.fileUrl;
            this.createdDate = model.createdDate;
            this.isDeleted = model.isDeleted;
        }
    };

    @MobX.action
    public toDto = (): ArmedForcesProofDTO => {
        let model: ArmedForcesProofDTO = {
            id: this.id,
            employmentDetailId: this.employmentDetailId,
            fileName: this.fileName,
            fileUrl: this.fileUrl,
            createdDate: this.createdDate,
            isDeleted: this.isDeleted,
        };
        return model;
    };
    @MobX.action
    public resetModel = (): void => {
        this.id = "";
        this.employmentDetailId = "";
        this.fileName = "";
        this.fileUrl = "";
        this.createdDate = null;
        this.isDeleted = false;
    };
}
